// extracted by mini-css-extract-plugin
export default {"loading":"loading__KVMF6j","loadingAnimation":"loadingAnimation__lGf7sr","fading":"fading__N_lKGn","loadingMessage":"loadingMessage__XCWBai","fading-grey":"fading-grey__Lrh4k9"};